/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'

import { Grid } from '../../packages/kiti/components/structure/Grid'
import { useColor } from '../../packages/kiti/components/theme/_hooks/colors'
import Text from '../../packages/kiti/components/presentation/Text'

const CardActions = ({ actions }) => {
  const color = useColor('light5')
  const hoverColor = useColor('light2')

  const style = css`
    border-top: solid 1px ${color};
    flex: 1;
    padding: 0.5rem 1rem;
    cursor: pointer;

    &:hover {
      background: ${hoverColor};
    }

    &:not(:first-child) {
      border-left: solid 1px ${color};
    }
  `

  return (
    <Grid borderTop="solid 1px black">
      {actions.map(action => (
        <div flex={1} key={action.label} css={style} onClick={action.onClick}>
          <Text size="xsmall" align="center" color={action.color || 'dark3'} bold>
            {action.label}
          </Text>
        </div>
      ))}
    </Grid>
  )
}

export default CardActions
